const HAD_SESSION_KEY = "studio:had_session";
const SIGNED_OUT_KEY = "studio:signed_out";

/** 本浏览器曾成功建立 Web 会话（用于区分冷启动 vs 会话过期）。 */
export function hadSessionBefore(): boolean {
  try {
    return localStorage.getItem(HAD_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function markHadSession(): void {
  try {
    localStorage.setItem(HAD_SESSION_KEY, "1");
  } catch {
    // ignore quota / private mode
  }
}

export function clearHadSession(): void {
  try {
    localStorage.removeItem(HAD_SESSION_KEY);
  } catch {
    // ignore
  }
}

/** 用户主动退出（会话过期页等流程）。 */
export function isSignedOut(): boolean {
  try {
    return sessionStorage.getItem(SIGNED_OUT_KEY) === "1";
  } catch {
    return false;
  }
}

export function markSignedOut(): void {
  try {
    sessionStorage.setItem(SIGNED_OUT_KEY, "1");
  } catch {
    // ignore
  }
}

export function clearSignedOut(): void {
  try {
    sessionStorage.removeItem(SIGNED_OUT_KEY);
  } catch {
    // ignore
  }
}
